<template>
  <div id="app">
    <router-view name="view"/>
    <OrganismTheAlerts/>
    <OrganismTheModal/>
  </div>
</template>

<script>
export default {
  name: 'App',

  components: {
    OrganismTheAlerts: () => import('@/components/organisms/OrganismTheAlerts'),
    OrganismTheModal: () => import('@/components/organisms/OrganismTheModal')
  },

  computed: {
    academyData () {
      return this.$store.getters.getAcademyData
    }
  },

  watch: {
    academyData () {
      if (this.academyData.color) {
        document.documentElement.style.setProperty('--color-brand-academy-primary', this.academyData.color)
        document.documentElement.style.setProperty('--color-brand-academy-secondary', `${this.academyData.color}8C`)
        document.documentElement.style.setProperty('--color-brand-account-primary', this.academyData.color)
        document.documentElement.style.setProperty('--color-brand-account-secondary', `${this.academyData.color}8C`)
      }

      if (this.academyData.nombre) {
        document.title = this.academyData.nombre
      }
    }
  },

  created () {
    if (this.academyData.color) {
      document.documentElement.style.setProperty('--color-brand-academy-primary', this.academyData.color)
      document.documentElement.style.setProperty('--color-brand-account-primary', this.academyData.color)
    }

    if (this.academyData.nombre) {
      document.title = this.academyData.nombre
    }
  }
}
</script>

<style src="./styles/main.css"></style>
